"use strict";
var link = document.location.pathname;

$(function () {
  if(!$.cookie('cookieAgree')) {
    var $cookieAgree = $('<div id="cookieAgree" style="display:none;"><button type="button" class="close" title="Соглашаюсь"><i class="fa fa-times" aria-hidden="true"></i></button><span>Мы используем cookie для быстрой и удобной работы сайта. Используя наш сайт, вы принимаете <a target="_blank" class="text-primary" href="//fobn.ru/privacy-policy/" rel="nofollow">условия обработки персональных данных</a>.</div>');
    $('body').append($cookieAgree);
    $('#cookieAgree').show('slow');
    $('#cookieAgree').on('click', '.close', () => {
      $('#cookieAgree').hide('slow');
      $.cookie('cookieAgree', 1);
    });
  }

  // if ( $('nav [href="'+link+'"]').length ) {
  // 	$('nav [href="'+link+'"]').parents('.nav-item').addClass('active');
  // }

  $('.navbar-nav a[href="'+ link +'"]').parents('.nav-item').addClass('active');
  $('.navbar-nav a[href="'+ link +'"].dropdown-item').addClass('active');

  // $('.dropdown').on('mouseover mouseout click', function(){
  //   $(this).find('[data-toggle="dropdown"]').dropdown('toggle');
  // });

  // var activeNavItemClass = '.link-'+link.split('/')[1];
  // if (link.split('/')[1]==''){ activeNavItemClass='.link-home'; }

  // if($(activeNavItemClass).length>0){
  //     if ($('nav .active').length>0) { $('nav .active').removeClass('active'); };
  //     $(activeNavItemClass).addClass('active');
  // }

  function pagesInPage(){
    var indPage, urlHash = document.location.hash,
      currentPage = 1;
    if ( urlHash != '' ) {
      indPage = urlHash.split('#page-')[1];
      if ( $('.paginator li.active').length>0 ) {
        $('.paginator li.active').removeClass('active');
      };
      if ( $('.page_item.active').length>0 ) {
        $('.page_item.active').removeClass('active');
      };
      $(urlHash).addClass('active');
      $('.elem-'+indPage).addClass('active');
    } else {
      $('#page-'+currentPage+', .elem-'+currentPage).addClass('active');
      // $('.elem-'+currentPage).addClass('active');
    };
  }

  function setPaginator(){
    var countPages = $('.page_item').length,
      elementPage, paginatorBlock, str = '';
    // console.log(countPages);
    for (var i = 1; i <= countPages; i++) {
      elementPage = '<li class="page-item elem-'+i+'"><a class="page-link" href="'+link+'#page-'+i+'">'+i+'</a></li>';
      str = str + elementPage;
    };
    paginatorBlock = '<nav aria-label="Page navigation">' +
      '<p class="text-center"><b>Страницы:</b></p>' +
      '<ul class="pagination justify-content-md-center">'+ str +'</ul>' +
      '</nav>';
    $('.paginator').html(paginatorBlock);
  }

  if ( $('.paginator').length>0 ) {
    setPaginator();
    pagesInPage();

    $('.paginator').on('click','a', function(){
      var href = $(this).attr('href');
      document.location.href = href;
      pagesInPage();
    })
  };

  if ( $('.g-recaptcha').length>0 ) {
    $('.g-recaptcha').data('sitekey','6LcEYgYTAAAAAMez3e_tcJDJBbwGe_uSVcv53WV6');
  };


})